import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Input } from '../../../common/Forms/Input/Input';
import { notify } from '../../../../assets/helpers/toast';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as schemas from '../../../../assets/schemas/schemas';
import { ActionButton, AltButton } from '../../../common/Buttons/Buttons';
import {
  idCodes,
  planTypes,
  vehicleDocumentTypeOptions,
  externalvehicleDocumentTypeOptions,
  documentTypeEnum,
  getVehicleBrandsPlanParam,
} from '../../../../assets/helpers/options';
import { statesService } from '../../../../services/statesService';
import { vehicleService } from '../../../../services/vehicleService';
import { armorTypesService } from '../../../../services/armorTypesService';
import { membershipService } from '../../../../services/membershipService';
import {
  clearObject,
  capitalize,
  filterSatesMotoriderAV,
  removeBlankSpacesAndUppercase,
  validateAndSet,
  filterParams,
  filterOptionById,
  filterOptionByName,
  base64ToBlob,
  findOptionByFuzzyName,
} from '../../../../assets/helpers/funciones';
import {
  SalesDropzone,
  FileComponent,
} from '../../../common/Dropzone/Dropzone';
import { useParams } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import { LoadSpinner } from '../../../common/LoadSpinner/LoadSpinner';
import './LandingForms.scss';
import authService from '../../../../services/authService';
import { RcvHolderForm } from '../../../common/Forms/Form';
import {
  preloadVehicleData,
  resolvePreloadTypeId,
  generateRandomPlate,
  handleTestImageUpload,
} from './helpers/preloadFuntions';
import { MultipleVehiclesTable } from '../MultipleAfiliationComponents/MultipleVehiclesTable';
import { multipleVehiclesTableHeader } from '../../../../assets/helpers/tables';
import { Autocomplete, LoadScript } from '@react-google-maps/api';

// createMassiveCustomerVehicle responde 200 aunque alguna membresía falle;
// el detalle viene en data.memberships[i].error
export const getMembershipErrors = (response) => {
  const memberships = response?.data?.memberships;
  if (!Array.isArray(memberships)) return [];
  return memberships
    .map((item, index) => ({ index, memId: item?.memId, error: item?.error }))
    .filter(({ error }) => ![null, undefined, ''].includes(error));
};

export const MultipleVehicleForm = React.memo((props) => {
  const {
    setcurentStep,
    curentStep,
    membership,
    customer,
    selectedMembership,
    membershipList,
    setMembershipList,
  } = props;

  const t = useTranslation();

  const [statesOptions, setStatesOptions] = useState([]);
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [ownerCitiesOptions, setOwnerCitiesOptions] = useState([]);
  const [RCVCitiesOptions, setRCVCitiesOptions] = useState([]);
  const [armorTypeOptions, setArmorTypeOptions] = useState([]);
  const [typesOptions, setTypesOptions] = useState([]);
  const [vehileError, setVehicleError] = useState(false);
  const [vehicleBrandOptions, setVehicleBrandOptions] = useState([]);
  const [vehicleModelOptions, setVehicleModelOptions] = useState([]);
  const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
  const [municipalitiesOptions, setMunicipalitiesOptions] = useState([]);
  const [circulationCard, setCirculationCard] = useState('');
  const [isLoading, setIsloading] = useState(false);
  const [customerIsOwner, setcustomerIsOwner] = useState('SI');
  const [isVehicleDriver, setIsVehicleDriver] = useState('SI');
  const { saleChannel } = useParams();
  const [clientNumber, setClientNumber] = useState(-1);
  const destinyRef = useRef();
  const clientNumberRef = useRef(-1);
  const membershipListRef = useRef(membershipList);
  const watchRef = useRef();
  const getDocumentsDataRef = useRef();
  const brandsRequestIdRef = useRef(0);

  const getDocumentsData = (file, documentType) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('documentType', documentType);

    setIsloading(true);
    membershipService
      .getDocumentsDataV2(formData)
      .then((response) => {
        if ([200, 201].includes(response.status)) {
          const res =
            response?.data?.[`${documentType}`] ||
            response?.data?.[`${documentType?.toUpperCase()}`] ||
            response?.data?.circulation ||
            {};
          if (!['true', true].includes(process.env.REACT_APP_DEVELOP)) {
            validateAndSet('plate', res?.plate, setValue, watch);
          }
          // validateAndSet('year', res?.year, setValue, watch);
          validateAndSet('bodySerial', res?.bodySerial, setValue, watch);
          validateAndSet('color', capitalize(res?.color), setValue, watch);
          validateAndSet('seats', res?.seats, setValue, watch);
          // Intentar inferir la clase primero (si viene en el OCR) y setearla,
          // luego solicitar los tipos usando esa clase para asegurar resultados.
          (async () => {
            try {
              const classId = watch('class');

              if (classId) {
                setValue('class', classId);
              }

              const types = await getVehicleTypes(classId);
              if (types && types.length > 0) {
                const selectedType = findOptionByFuzzyName(types, res?.type);
                if (selectedType) {
                  setValue('type', selectedType?._id);
                }
              }
            } catch (e) {}
          })();
          const currentMembership =
            membershipListRef.current?.[clientNumberRef.current];
          Promise.all([getVehicleBrands(currentMembership)]).then(([brands]) => {
            if (brands.length > 0) {
              const selectedBrand = findOptionByFuzzyName(brands, res?.brand);
              if (selectedBrand) {
                setValue('brand', selectedBrand?._id);
                getVehicleModels(selectedBrand?._id).then((models) => {
                  if (models && models.length > 0) {
                    const selectedModel = findOptionByFuzzyName(
                      models,
                      res?.model
                    );
                    if (selectedModel) {
                      setValue('model', selectedModel?._id);
                    }
                  }
                });
              }
            }
          });
          setIsloading(false);
        } else {
          setIsloading(false);
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {
        setIsloading(false);
      });
  };

  getDocumentsDataRef.current = getDocumentsData;

  const onDrop1 = useCallback((acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();

      reader.onload = () => {
        // Do whatever you want with the file contents
      };
      reader.readAsArrayBuffer(file);

      if (
        !['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'].includes(
          file.type
        )
      ) {
        notify('Agregar un formato valido de imagen', 'error');
        return null;
      }
      let maxWeight = 5;
      if (file.size * 0.000001 > maxWeight) {
        notify(`La imagen no debe superar los ${maxWeight} MB`, 'error');
      } else {
        setCirculationCard(file);
        const documentType = watchRef.current?.('documentTypeImage');
        getDocumentsDataRef.current?.(file, documentType);
      }
    });
  }, []);

  const updateLocationStatus = () => {
    setValue('address', destinyRef.current.value);
    // Check if any state name matches a substring in destinyRef.current.value
    const matchedState = statesOptions.find(
      (state) =>
        destinyRef.current.value &&
        typeof destinyRef.current.value === 'string' &&
        destinyRef.current.value
          .toLowerCase()
          .includes(state.name.toLowerCase())
    );

    if (matchedState) {
      setValue('state', matchedState._id);
      getAndSetCities(matchedState._id);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    control,
    reset,
  } = useForm({
    resolver: yupResolver(schemas.RegisterVehicleSchema(t)),
  });

  clientNumberRef.current = clientNumber;
  membershipListRef.current = membershipList;
  watchRef.current = watch;

  const addVehicle = (index) => {
    setcustomerIsOwner('SI');
    setValue('customerIsOwner', true);
    clientNumberRef.current = index;
    setClientNumber(index);
    setVehicleBrandOptions([]);
    setVehicleModelOptions([]);
    setValue(
      'class',
      filterOptionById(
        vehicleClassesOptions,
        membershipList[index].dataTable?.classId
      )?._id
    );
    setValue('year', membershipList[index].dataTable?.year);
    setValue(
      'armorType',
      membershipList[index].dataTable?.armorTypeId.toLowerCase()
    );
    getVehicleBrands(membershipList[index]);
    setTimeout(() => {
      getVehicleTypes();
    }, 1500);
  };

  const editVehicle = (index) => {
    clientNumberRef.current = index;
    setClientNumber(index);
    setVehicleBrandOptions([]);
    setVehicleModelOptions([]);
    getVehicleBrands(membershipList[index]);
    setCirculationCard(membershipList[index].dataTable?.circulationCard);

    setValue(
      'documentTypeImage',
      membershipList[index].dataTable?.vehicleDocumentTypeImage
    );
    setValue('class', membershipList[index].vehicle?.class);
    setValue('plate', membershipList[index].vehicle?.plate);

    // Get Vehicle Models and Types
    Promise.allSettled([
      getVehicleModels(membershipList[index].vehicle?.brand),
      getVehicleTypes(membershipList[index].vehicle?.class),
    ]).then((r) => {
      setTimeout(() => {
        setValue('type', membershipList[index].vehicle?.type);
        setValue('brand', membershipList[index].vehicle?.brand);
        setValue('model', membershipList[index].vehicle?.model);
      }, 1500);
    });

    setValue('color', membershipList[index].vehicle?.color);
    setValue('year', membershipList[index].vehicle?.year);
    // setValue("km", membershipList[index].vehicle?.km)
    setValue('armorType', membershipList[index].dataTable?.armorTypeId);
    //Get cities
    Promise.allSettled([
      getCities(membershipList[index].vehicle?.state),
      getMunicipalities(membershipList[index].vehicle?.city),
    ]).then((r) => {
      setTimeout(() => {
        setValue('state', membershipList[index].vehicle?.state);
        setValue('city', membershipList[index].vehicle?.city);
        setValue('municipality', membershipList[index].vehicle?.municipality);
      }, 1500);
    });

    setValue('address', membershipList[index].vehicle?.address);
    // RCV Info
    setValue('bodySerial', membershipList[index].vehicle?.bodySerial);
    setValue('seats', membershipList[index].vehicle?.seats);

    if (membershipList[index].vehicle?.customerIsOwner === 'true') {
      setValue('customerIsOwner', true);
      setcustomerIsOwner('SI');
    } else if (membershipList[index].vehicle?.customerIsOwner === 'false') {
      setValue('customerIsOwner', false);
      setcustomerIsOwner('NO');
    }

    let isVehicleDriver = JSON.parse(
      membershipList[index].vehicle?.rcvHolder
    )?.isVehicleDriver;

    if (['true', true].includes(isVehicleDriver)) {
      setValue('isVehicleDriver', 'true');
    }
    if (['false', false].includes(isVehicleDriver)) {
      setValue('isVehicleDriver', 'false');
    }
  };

  const validateVehicle = (vehicle) => {
    let dataToPost = { ...vehicle };

    dataToPost.membership = membershipList[clientNumber]?.membership;
    dataToPost.hasCirculationCard = circulationCard?.name ? true : false;
    dataToPost.armored =
      watch('armorType') &&
      filterOptionById(armorTypeOptions, watch('armorType'))?.name !== 'No'
        ? true
        : false;

    dataToPost.rcvHolder = JSON.stringify(dataToPost.rcvHolder);

    if (!isLoading) {
      setIsloading(true);
      vehicleService
        .validateCreate(dataToPost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            setIsloading(false);

            let vehicle = dataToPost;
            let data = [...membershipList];
            data[clientNumber].dataTable.model = capitalize(
              filterOptionById(vehicleModelOptions, watch('model')).name
            );
            data[clientNumber].dataTable.brand = capitalize(
              filterOptionById(vehicleBrandOptions, watch('brand')).name
            );
            data[clientNumber].dataTable.state = capitalize(
              filterOptionById(statesOptions, watch('state')).name
            );
            data[clientNumber].dataTable.city = capitalize(
              filterOptionById(citiesOptions, watch('city')).name
            );
            data[clientNumber].dataTable.municipality = capitalize(
              filterOptionById(municipalitiesOptions, watch('municipality'))
                .name
            );
            data[clientNumber].dataTable.address = watch('address');
            // Document Load
            data[clientNumber].dataTable.circulationCard = circulationCard;
            data[clientNumber].vehicle = vehicle;
            data[clientNumber].dataTable.vehicleDocumentTypeImage =
              watch('documentTypeImage');

            setCirculationCard('');
            clientNumberRef.current = -1;
            setClientNumber(-1);
            setVehicleBrandOptions([]);
            setVehicleModelOptions([]);
            reset();
          } else {
            setIsloading(false);
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  };

  const onSubmit = handleSubmit(async (data) => {
    setVehicleError(false);

    data.plate = data?.plate?.toUpperCase();
    data.bodySerial = data?.bodySerial?.toUpperCase();
    data.color = capitalize(data?.color);

    if (!circulationCard && !saleChannel) {
      // notify('Adjunte su carnet de circulación', 'info');
      notify('Adjunte su título de propiedad del vehículo', 'error');
      setVehicleError(true);
      return null;
    }

    data.rcvHolder = clearObject(data.rcvHolder);
    data = clearObject(data);
    data.rcvHolder = {
      isVehicleDriver: isVehicleDriver === 'SI' ? true : false,
      firstName: data?.rcvHolderFirstName,
      lastName: data?.rcvHolderLastName,
      fullName: `${data?.rcvHolderFirstName} ${data?.rcvHolderLastName}`,
      identificationType: data?.rcvHolderIdentificationType,
      identification: data?.rcvHolderIdentification,
      phonePrefix: data?.rcvHolderPhonePrefix,
      phoneNumber: data?.rcvHolderPhoneNumber,
      address: data?.rcvHolderAddress,
      state: data?.rcvHolderState,
      city: data?.rcvHolderCity,
    };

    if (!data?.rcvHolderFirstName && !data?.rcvHolderLastName) {
      delete data.rcvHolder.fullName;
    }

    delete data.rcvHolderFirstName;
    delete data.rcvHolderLastName;
    delete data.rcvHolderIdentificationType;
    delete data.rcvHolderIdentification;
    delete data.rcvHolderPhonePrefix;
    delete data.rcvHolderPhoneNumber;
    delete data.rcvHolderAddress;
    delete data.rcvHolderState;
    delete data.rcvHolderCity;
    delete data.isVehicleDriver;

    let vehicle = { ...data };

    if (filterOptionById(armorTypeOptions, watch('armorType'))?.name !== 'No') {
      delete vehicle.armorType;
    }

    delete vehicle.documentTypeImage;

    if (authService.getUser()) {
      validateVehicle(filterParams(vehicle));
      return null;
    }

    let fileTopost = appendFile(vehicle);
    vehicle.brandName = capitalize(
      vehicleBrandOptions?.filter((c) => c?._id === vehicle?.brand)[0]?.name
    );
    vehicle.modelName = vehicleModelOptions?.filter(
      (c) => c?._id === vehicle?.model
    )[0]?.name;

    vehicle.stateName = capitalize(
      statesOptions?.filter((c) => c?._id === vehicle?.state)[0]?.name
    );
    vehicle.cityName = capitalize(
      citiesOptions?.filter((c) => c?._id === vehicle?.city)[0]?.name
    );
    vehicle.municipalityName = capitalize(
      municipalitiesOptions?.filter((c) => c?._id === vehicle?.municipality)[0]
        ?.name
    );

    if (!isLoading) {
      setIsloading(true);
      vehicleService
        .createVehicle(fileTopost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            setIsloading(false);
            sessionStorage.setItem('vehicle', JSON.stringify(vehicle));
            setcurentStep(curentStep + 1);
          } else {
            setIsloading(false);
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const getCities = (state) => {
    statesService
      .getCities(state ? state : watch('state'), true)
      .then((response) => {
        if (response.status === 200) {
          setCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
    return true;
  };

  const getAndSetCities = (state) => {
    statesService
      .getCities(state ? state : watch('state'), true)
      .then((response) => {
        if (response.status === 200) {
          setCitiesOptions(response?.data?.cities);
          const matchedCity = response?.data?.cities.find(
            (city) =>
              destinyRef.current.value &&
              typeof destinyRef.current.value === 'string' &&
              destinyRef.current.value
                .toLowerCase()
                .includes(city.name.toLowerCase())
          );

          if (matchedCity) {
            setValue('city', matchedCity._id);
            getMunicipalities(matchedCity._id);
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
    return true;
  };

  const getStates = () => {
    statesService
      .getStates({ isActive: true })
      .then((response) => {
        if (response.status === 200) {
          let states = response?.data?.states;

          if (selectedMembership?.code === planTypes?.MOTORIDERAV) {
            states = filterSatesMotoriderAV(states);
          }

          setStatesOptions(states);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const handleCity = (e) => {
    getRCVCities(e.target.value);
  };

  const getOwnerCities = (ownerState) => {
    statesService
      .getCities(ownerState ? ownerState : watch('ownerState'), true)
      .then((response) => {
        if (response.status === 200) {
          setOwnerCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
    return true;
  };

  const getRCVCities = (RCVCities) => {
    statesService
      .getCities(RCVCities ? RCVCities : watch('ownerState'), true)
      .then((response) => {
        if (response.status === 200) {
          setRCVCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
    return true;
  };

  const getMunicipalities = (city) => {
    statesService
      .getMunicipalities(city ? city : watch('city'), true)
      .then((response) => {
        if (response.status === 200) {
          setMunicipalitiesOptions(response?.data?.municipalities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
    return true;
  };

  const appendFile = (rawData) => {
    let data = { ...rawData };

    const formData = new FormData();
    if (data.rcvHolder) {
      data.rcvHolder = JSON.stringify(data.rcvHolder);
    }
    for (const key in data) {
      formData.append(key, data[key]);
    }

    if (circulationCard) {
      formData.append('circulation-card', circulationCard);
    }

    if (saleChannel) {
      formData.append('landing', 'Marqueting qr');
    }
    formData.append('customer', customer);
    formData.append('membership', membership?._id);
    formData.append('armored', watch('armorType'));
    return formData;
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop: onDrop1 });

  const getSalesVehicleClasses = async () => {
    return vehicleService
      .getSalesVehicleClasses()
      .then((response) => {
        if (response.status === 200) {
          setVehicleClassesOptions(response?.data?.classes);
          return response?.data?.classes || [];
        } else {
          notify(`${response.message}` || 'error', 'error');
          return [];
        }
      })
      .catch(() => {
        return [];
      });
  };
  const getArmorTypes = () => {
    armorTypesService
      .getArmorTypes()
      .then((response) => {
        if (response.status === 200) {
          setArmorTypeOptions([...response?.data]);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
  };

  // const preloadValues = () => {
  //   let vehicleData = sessionStorage.getItem('vehicle');
  //   let customer = sessionStorage.getItem('customer');
  //   vehicleData = JSON.parse(vehicleData);
  //   customer = JSON.parse(customer);

  //   if (!authService?.getUser()) {
  //     setValue('documentTypeImage', documentTypeEnum?.CERTIFICATE_OR_TITLE);
  //   }

  //   if (customer) {
  //     setValue('profession', customer?.profession);
  //     setTimeout(() => {
  //       setValue('economicActivity', customer?.economicActivity);
  //     }, 1200);
  //   }

  //   if (vehicleData) {
  //     setValue('year', vehicle?.year);
  //     setValue('bodySerial', vehicleData?.bodySerial);
  //     setValue('color', vehicleData?.color);
  //     setValue('plate', vehicleData?.plate);
  //     setValue('bodySerial', vehicleData?.bodySerial);
  //     setValue('km', vehicleData?.km);

  //     Promise.allSettled([
  //       getVehicleTypes(vehicleData?.class),
  //       getSalesVehicleClasses(),
  //       getVehicleBrands(),
  //       getVehicleModels(vehicleData?.brand),
  //       getArmorTypes(),
  //       getStates(),
  //       getCities(vehicleData?.state),
  //       getMunicipalities(vehicleData?.city),
  //     ]).then((r) => {
  //       setTimeout(() => {
  //         // Address info
  //         setValue('state', vehicleData?.state);
  //         setValue('city', vehicleData?.city);
  //         setValue('municipality', vehicleData?.municipality);
  //         setValue('address', vehicleData?.address);
  //         setValue('addressReference', vehicleData?.addressReference);
  //         // Vehicle Info
  //         setValue('armorType', vehicleData?.armorType);
  //         setValue('class', vehicleData?.class);
  //         setValue('type', vehicleData?.type);
  //         setValue('brand', vehicleData?.brand);
  //         setValue('model', vehicleData?.model);
  //         setValue('type', vehicleData?.type);
  //       }, 500);
  //     });

  //     if (vehicleData?.customerIsOwner) {
  //       setValue('customerIsOwner', true);
  //       setcustomerIsOwner('SI');
  //     } else {
  //       setValue('customerIsOwner', false);
  //       setcustomerIsOwner('NO');
  //       setValue('ownerFirstName', vehicleData?.ownerFirstName);
  //       setValue('ownerLastName', vehicleData?.ownerLastName);
  //       setValue(
  //         'ownerIdentificationType',
  //         vehicleData?.ownerIdentificationType
  //       );
  //       setValue('ownerIdentification', vehicleData?.ownerIdentification);
  //       setValue('ownerAddress', vehicleData?.ownerAddress);

  //       Promise.allSettled([
  //         getStates(),
  //         getOwnerCities(vehicleData?.ownerState),
  //       ]).then((r) => {
  //         setTimeout(() => {
  //           setValue('ownerState', vehicleData?.ownerState);
  //           setValue('ownerCity', vehicleData?.ownerCity);
  //         }, 500);
  //       });
  //     }
  //   } else {
  //     setValue('year', vehicle?.year);
  //     setValue('customerIsOwner', true);
  //     Promise.allSettled([
  //       getVehicleTypes(vehicle?.class),
  //       getSalesVehicleClasses(),
  //       getArmorTypes(),
  //     ]).then((r) => {
  //       setTimeout(() => {
  //         setValue('armorType', vehicle?.armorType);
  //         setValue('class', vehicle?.class);
  //         setValue('type', vehicle?.type);
  //       }, 500);
  //     });
  //   }
  // };

  const getVehicleTypes = (clase) => {
    if (clase || watch('class')) {
      return vehicleService
        .getVehicleTypes({ class: clase || watch('class') })
        .then((response) => {
          if (response.status === 200) {
            const types = response?.data?.types;
            setTypesOptions(types);
            return types;
          } else {
            notify(`${response.message}` || 'error', 'error');
            return [];
          }
        })
        .catch((error) => {
          return [];
        });
    }
    return Promise.resolve([]);
  };

  const resolveMembershipForBrands = (membershipRef) => {
    if (membershipRef) return membershipRef;
    const index = clientNumberRef.current;
    const list = membershipListRef.current;
    if (index >= 0 && list?.[index]) return list[index];
    return selectedMembership;
  };

  const getVehicleBrands = (membershipRef) => {
    const requestId = ++brandsRequestIdRef.current;
    return vehicleService
      .getVehicleBrands(
        undefined,
        getVehicleBrandsPlanParam(resolveMembershipForBrands(membershipRef))
      )
      .then((response) => {
        if (requestId !== brandsRequestIdRef.current) {
          return [];
        }
        if (response.status === 200) {
          const brandsData = response?.data?.vehicleBrands;
          setVehicleBrandOptions(brandsData);
          return brandsData;
        } else {
          notify(`${response.message}`, 'error');
          return [];
        }
      })
      .catch((error) => {
        return [];
      });
  };

  const getVehicleModels = (vehicleBrandId) => {
    return vehicleService
      .getVehicleModels(vehicleBrandId)
      .then((response) => {
        if (response.status === 200) {
          const models = response?.data?.models;
          setVehicleModelOptions(models);
          return models;
        } else {
          notify(`${response.message}`, 'error');
          return [];
        }
      })
      .catch((error) => {
        return [];
      });
  };

  const handlecustomerIsOwner = (e) => {
    if (e?.target?.value === 'SI') {
      setValue('customerIsOwner', true);
      setcustomerIsOwner(e?.target?.value);
      clearTitularForm();
    }
    if (e?.target?.value === 'NO') {
      setValue('customerIsOwner', false);
      setcustomerIsOwner(e?.target?.value);
      clearTitularForm();
    }
  };

  const handleRCVHolder = (e) => {
    if (e?.target?.value === 'SI') {
      setValue('isVehicleDriver', true);
      setIsVehicleDriver(e?.target?.value);
      clearRCVForm();
    }
    if (e?.target?.value === 'NO') {
      setValue('isVehicleDriver', false);
      setIsVehicleDriver(e?.target?.value);
      clearRCVForm();
    }
  };

  const clearRCVForm = () => {
    setValue('rcvHolderFirstName', '');
    setValue('rcvHolderLastName', '');
    setValue('rcvHolderIdentificationType', '');
    setValue('rcvHolderIdentification', '');
    setValue('rcvHolderState', '');
    setValue('rcvHolderCity', '');
    setValue('rcvHolderPhonePrefix', '');
    setValue('rcvHolderPhoneNumber', '');
    setValue('rcvHolderAddress', '');
  };

  const clearTitularForm = () => {
    setValue('ownerFirstName', '');
    setValue('ownerLastName', '');
    setValue('ownerState', '');
    setValue('ownerCity', '');
    setValue('ownerAddress', '');
    setValue('ownerIdentificationType', '');
    setValue('ownerIdentification', '');
  };

  const preloadValues = async (classesParam) => {
    let vehicleDataImg = sessionStorage.getItem('idUploaded');
    let data = localStorage.getItem('documentsInfo');
    data = JSON.parse(data);

    if (
      (data && data?.circulation) ||
      data?.originCertificate ||
      data?.registryCertifate ||
      data?.buyCertificate
    ) {
      if (data?.circulation) {
        setValue('documentTypeImage', documentTypeEnum?.CIRCULATION_CARD);
      }
      if (data?.originCertificate) {
        setValue('documentTypeImage', documentTypeEnum?.ORIGIN_CERTIFICATE);
      }
      if (data?.registryCertifate) {
        setValue('documentTypeImage', documentTypeEnum?.CERTIFICATE_OR_TITLE);
      }
      if (data?.buyCertificate) {
        setValue('documentTypeImage', documentTypeEnum?.PURCHASE_DOCUMENT);
      }

      if (vehicleDataImg) {
        const imageFile = base64ToBlob(vehicleDataImg);
        imageFile.name = 'documento-vehiculo.jpg';
        setCirculationCard(imageFile);
      }

      validateAndSet('bodySerial', data?.bodySerial || '', setValue, watch);
      validateAndSet('color', data?.color || '', setValue, watch);
      validateAndSet('plate', data?.plate || '', setValue, watch);
      // validateAndSet('year', data?.year || '', setValue, watch);
      validateAndSet('seats', data?.seats, setValue, watch);

      // usar classesParam (si se pasó) o vehicleClassesOptions como fallback
      const classesSource = classesParam || vehicleClassesOptions;
      const classId = filterOptionById(
        classesSource,
        membershipList[0].dataTable?.classId
      )?._id;

      if (classId) {
        setValue('class', classId);
      }

      try {
        const [types, brands] = await Promise.all([
          getVehicleTypes(classId),
          getVehicleBrands(membershipList?.[0]),
        ]);

        if (types && types.length > 0) {
          const selectedType = findOptionByFuzzyName(types, data?.type);
          if (selectedType) setValue('type', selectedType?._id);
        }

        if (brands && brands.length > 0) {
          const selectedBrand = findOptionByFuzzyName(brands, data?.brand);
          if (selectedBrand) {
            setValue('brand', selectedBrand?._id);
            const models = await getVehicleModels(selectedBrand?._id);
            if (models && models.length > 0) {
              const selectedModel = findOptionByFuzzyName(models, data?.model);
              if (selectedModel) setValue('model', selectedModel?._id);
            }
          }
        }
      } catch (e) {
        // no hacemos nada, isloading se limpia abajo
      } finally {
        setIsloading(false);
      }

      localStorage.removeItem('documentsInfo');
      sessionStorage.removeItem('idUploaded');
    } else {
      localStorage.removeItem('documentsInfo');
      sessionStorage.removeItem('idUploaded');
      return;
    }
  };

  useEffect(() => {
    const init = async () => {
      setIsloading(true);
      // obtener clases primero y pasar el resultado a preloadValues
      const classes = await getSalesVehicleClasses();
      // cargar el resto de datos en paralelo
      await Promise.all([
        getArmorTypes(),
        getStates(),
      ]);
      // ahora preloadValues puede usar las clases retornadas
      await preloadValues(classes);
      setIsloading(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let validateDisabled = () => {
    return false;
  };

  let validateIfshowForm = () => {
    if (saleChannel) {
      return true;
    }
    if (watch('documentTypeImage')) {
      return true;
    } else return false;
  };

  const validateButton = () => {
    let label = '';

    if (membershipList[clientNumber]?.vehicle) {
      label = 'Editar vehículo';
    } else {
      label = 'Agregar vehículo';
    }

    if (clientNumber >= 0) {
      return (
        <ActionButton
          label={authService.getUser() ? label : 'Siguiente'}
          action={onSubmit}
        />
      );
    } else return null;
  };

  const validateContinueButton = () => {
    let canPass = true;

    for (let i = 0; i < membershipList.length; i++) {
      if (!membershipList[i].vehicle) {
        canPass = false;
      }
    }

    if (authService.getUser() && canPass && clientNumber < 0) {
      return (
        <ActionButton
          label={'Confirmar'}
          action={() => createMassiveVehicle()}
        />
      );
    } else return null;
  };

  const getDocumentTypes = () => {};

  const getVehicleDataFromStorage = () => {
    let vehicleData = localStorage.getItem('documentsInfo');
    let image = sessionStorage.getItem('idUploaded');
    const imageFile = base64ToBlob(image);
    setCirculationCard(imageFile);
    vehicleData = JSON.parse(vehicleData);
    if (vehicleData) {
      setValue('year', vehicleData?.year || '');
      setValue('bodySerial', vehicleData?.bodySerial || '');
      setValue('color', vehicleData?.color || '');
      setValue('plate', vehicleData?.plate || '');
      setValue('documentTypeImage');

      getVehicleTypes().then((types) => {
        if (types.length > 0) {
          const selectedType = filterOptionByName(types, vehicleData?.type);
          if (selectedType) {
            setValue('type', selectedType?._id);
          }
        }
      });
      Promise.all([getVehicleBrands()]).then(([brands]) => {
        if (brands.length > 0) {
          const selectedBrand = filterOptionByName(brands, vehicleData?.brand);
          if (selectedBrand) {
            setValue('brand', selectedBrand?._id);
            getVehicleModels(selectedBrand?._id).then((models) => {
              if (models && models.length > 0) {
                const selectedModel = filterOptionByName(
                  models,
                  vehicleData?.model
                );
                if (selectedModel) {
                  setValue('model', selectedModel?._id);
                }
              }
            });
          }
        }
      });
    }
  };

  // parse img from base64

  const preloadPage = async (membershipList) => {
    if (authService.getUser()) {
      setValue('year', membershipList[clientNumber]?.dataTable?.year);
      setValue(
        'armorType',
        membershipList[clientNumber]?.dataTable?.armorTypeId
      );
    }

    setValue('documentTypeImage', documentTypeEnum?.CERTIFICATE_OR_TITLE);
    handleTestImageUpload(
      onDrop1,
      `${process.env.PUBLIC_URL}/TituloPrueba.jpeg`,
      'TituloPrueba.jpeg'
    );

    const classId = watch('class');
    const types = classId ? await getVehicleTypes(classId) : [];
    const typeId = resolvePreloadTypeId(types);

    getVehicleModels('6469228923c7f1fa25cd42a3');
    getCities('64695c7b447d0aa9c65969f7');
    getMunicipalities('64695ffba034e218fab88f15');
    getOwnerCities('64695c7b447d0aa9c65969f7');
    setTimeout(() => {
      preloadVehicleData(
        setValue,
        membership,
        membershipList[clientNumber],
        watch,
        typeId
      );
    }, 1500);

    setTimeout(() => {
      setValue('plate', generateRandomPlate());
    }, 2500);
  };

  const createMassiveVehicle = () => {
    const normalizedPlates = membershipList
      .map((item) => item?.vehicle?.plate)
      .filter(Boolean)
      .map((plate) => String(plate).trim().toUpperCase());

    const uniquePlates = new Set(normalizedPlates);
    if (uniquePlates.size !== normalizedPlates.length) {
      notify('dos o mas vehiculos poseen la misma placa', 'error');
      return;
    }

    let data = [...membershipList];
    for (let i = 0; i < data.length; i++) {
      data[i].vehicle.membership = membershipList[i]?.membership;
    }

    setMembershipList(data);

    let formData = new FormData();
    for (let i = 0; i < membershipList.length; i++) {
      formData.append(`data[${i}][membership]`, membershipList[i]?.membership);
      for (const key in membershipList[i]?.vehicle) {
        formData.append(
          `data[${i}][vehicle][${key}]`,
          membershipList[i]?.vehicle[key]
        );
      }
      for (const key in membershipList[i]?.customer) {
        formData.append(
          `data[${i}][customer][${key}]`,
          membershipList[i]?.customer[key]
        );
      }
      formData.append(`dni`, membershipList[i]?.dataTable?.dni);
      formData.append(
        `circulationCard`,
        membershipList[i]?.dataTable?.circulationCard
      );
    }

    if (!isLoading) {
      setIsloading(true);
      membershipService
        .createMassiveCustomerVehicle(formData)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            setIsloading(false);
            const membershipErrors = getMembershipErrors(response);
            if (membershipErrors.length > 0) {
              membershipErrors.forEach(({ index, error }) => {
                const plate = membershipList[index]?.vehicle?.plate;
                notify(
                  plate ? `Vehículo ${plate}: ${error}` : `${error}`,
                  'error'
                );
              });
              return;
            }
            setcurentStep(curentStep + 1);
          } else {
            setIsloading(false);
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  };

  const editClient = (index) => {
    setcurentStep(curentStep - 1);
    sessionStorage.setItem('clientIndex', JSON.stringify(index));
  };

  const multipleVehiclesTable = {
    header: multipleVehiclesTableHeader,
    data: membershipList,
    actions: {
      addVehicle: addVehicle,
      editVehicle: editVehicle,
      editClient: editClient,
    },
    curentStep: curentStep,
    clientNumber: clientNumber,
  };

  return (
    <>
      <LoadSpinner show={isLoading} />
      <div className="landing-form-container">
        <h5
          onClick={
            ['true', true].includes(process.env.REACT_APP_DEVELOP)
              ? () => preloadPage(membershipList)
              : ''
          }
        >
          Información del Vehículo
        </h5>
        <p>(*) Campos obligatorios</p>
        <br />
        <MultipleVehiclesTable table={multipleVehiclesTable} />

        {(!authService.getUser() || clientNumber >= 0) && (
          <form className="responsive-landing-form">
            <div className="row">
              <div className="col-12">
                <div className="buttons-center-container">
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Tipo de Documento *'}
                    type={'select'}
                    name={'documentTypeImage'}
                    register={register}
                    capitalizeOff={true}
                    placeholder={''}
                    options={
                      authService?.getUser()
                        ? vehicleDocumentTypeOptions
                        : externalvehicleDocumentTypeOptions
                    }
                    errors={errors?.documentTypeImage?.message}
                  />
                </div>
                {validateIfshowForm() && (
                  <>
                    {circulationCard ? (
                      <FileComponent
                        file={circulationCard}
                        remove={() => setCirculationCard('')}
                      />
                    ) : (
                      <SalesDropzone
                        // instructions={'Adjuntar carnet de circulación*'}
                        instructions={
                          'Adjuntar Título de propiedad del vehículo*'
                        }
                        maxWeight={'(JPG, PNG, PDF, máx. 3MB)'}
                        getRootProps={getRootProps}
                        getInputProps={getInputProps}
                        message="Arrastrar o buscar Documento"
                        error={vehileError}
                      />
                    )}
                  </>
                )}
              </div>
              {validateIfshowForm() && (
                <>
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Clase *'}
                    type={'select'}
                    name={'class'}
                    register={register}
                    placeholder={''}
                    options={vehicleClassesOptions}
                    errors={errors?.class?.message}
                    onChange={(e) => getVehicleTypes(e.target.value)}
                    disabled={true}
                  />
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Tipo *'}
                    type={'select'}
                    name={'type'}
                    register={register}
                    placeholder={''}
                    options={typesOptions}
                    errors={errors?.type?.message}
                    disabled={validateDisabled()}
                  />{' '}
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Placa *'}
                    type={'text'}
                    name={'plate'}
                    register={register}
                    placeholder={''}
                    errors={errors?.plate?.message}
                    onChange={(e) =>
                      removeBlankSpacesAndUppercase(
                        watch('plate'),
                        'plate',
                        setValue
                      )
                    }
                    disabled={validateDisabled()}
                  />{' '}
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Marca *'}
                    type={'select'}
                    options={vehicleBrandOptions}
                    name={'brand'}
                    register={register}
                    placeholder={''}
                    errors={errors?.brand?.message}
                    disabled={validateDisabled()}
                    onChange={() => getVehicleModels(watch('brand'))}
                  />{' '}
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Modelo *'}
                    type={'select'}
                    name={'model'}
                    register={register}
                    placeholder={''}
                    options={vehicleModelOptions}
                    errors={errors?.model?.message}
                    disabled={watch('brand') ? false : true}
                  />{' '}
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Color *'}
                    type={'text'}
                    name={'color'}
                    register={register}
                    placeholder={''}
                    errors={errors?.color?.message}
                  />{' '}
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Año *'}
                    type={'number'}
                    name={'year'}
                    register={register}
                    placeholder={''}
                    control={control}
                    errors={errors?.year?.message}
                    disabled={true}
                  />
                  {/* <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Kilometraje del vehículo'}
                    type={'number'}
                    name={'km'}
                    register={register}
                    placeholder={''}
                    errors={errors?.km?.message}
                    disabled={validateDisabled()}
                    min={'0'}
                  /> */}
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Blindaje'}
                    type={'select'}
                    options={armorTypeOptions}
                    name={'armorType'}
                    register={register}
                    errors={errors?.armorType?.message}
                    disabled={true}
                  />{' '}
                  <div className="input-component-container col-12 col-md-6">
                    <label>Dirección*</label>
                    <LoadScript
                      googleMapsApiKey={
                        process.env.REACT_APP_GOOGLE_MAPS_API_KEY
                      }
                      libraries={['places']}
                    >
                      <Autocomplete
                        restrictions={{ country: 've' }}
                        language="es"
                      >
                        <input
                          id="destinyRef"
                          className="input-map"
                          placeholder="Calle, Avenida, residencia o local"
                          ref={destinyRef}
                          style={{ fontSize: '12px', margin: '0px' }}
                          onClick={() => updateLocationStatus()}
                          onBlur={() => updateLocationStatus()}
                          onSelect={() => updateLocationStatus()}
                        />
                      </Autocomplete>
                    </LoadScript>
                  </div>
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Estado *'}
                    type={'select'}
                    options={statesOptions}
                    name={'state'}
                    placeholder={'Seleccione'}
                    register={register}
                    errors={errors?.state?.message}
                    onChange={(e) => getCities(watch('state'))}
                    disabled={validateDisabled()}
                  />{' '}
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Ciudad *'}
                    type={'select'}
                    options={citiesOptions}
                    name={'city'}
                    placeholder={'Seleccione'}
                    register={register}
                    errors={errors?.city?.message}
                    onChange={(e) => getMunicipalities()}
                    disabled={watch('state') ? false : true}
                  />{' '}
                  <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Municipio *'}
                    type={'select'}
                    options={municipalitiesOptions}
                    name={'municipality'}
                    placeholder={'Seleccione'}
                    register={register}
                    errors={errors?.municipality?.message}
                    disabled={watch('city') ? false : true}
                  />{' '}
                  {/* <Input
                    bootstrap={'col-12 col-md-6'}
                    label={'Dirección*'}
                    type={'textarea'}
                    name={'address'}
                    placeholder={
                      'Ejemplo: Chacao Av. Blandín, con Calle Santa Teresa de Jesús, C.C. San Ignacio, Sotano 1'
                    }
                    register={register}
                    errors={errors?.address?.message}
                    disabled={validateDisabled()}
                  /> */}
                  {((authService.getUser() &&
                    membershipList[clientNumber]?.dataTable?.rcv !== 'N/A') ||
                    (!authService.getUser() && membership?.rcv !== 'N/A')) && (
                    <>
                      <h5
                        style={{
                          textAlign: 'center',
                          marginTop: '24px',
                          marginBottom: '12px',
                        }}
                      >
                        Información para RCV
                      </h5>
                      <Input
                        bootstrap={'col-12 col-md-6'}
                        label={
                          'Serial Carrocería (en el carnet de circulación)'
                        }
                        type={'text'}
                        name={'bodySerial'}
                        register={register}
                        placeholder={''}
                        errors={errors?.bodySerial?.message}
                        onChange={(e) =>
                          removeBlankSpacesAndUppercase(
                            watch('bodySerial'),
                            'bodySerial',
                            setValue
                          )
                        }
                        disabled={validateDisabled()}
                      />{' '}
                      <Input
                        bootstrap={'col-12 col-md-6'}
                        label={'Puestos del Vehículo'}
                        type={'number'}
                        name={'seats'}
                        register={register}
                        placeholder={''}
                        errors={errors?.seats?.message}
                      />
                    </>
                  )}
                  <div className="col-12 col-md-6 checbox-input-container">
                    <label htmlFor="">¿Eres el titular del vehículo?</label>
                    <div className="checbox-input-container-midle">
                      <div className="topping">
                        <input
                          type="checkbox"
                          id="topping"
                          name="customerIsOwner"
                          value={'SI'}
                          checked={customerIsOwner === 'SI'}
                          onChange={handlecustomerIsOwner}
                        />
                        Si
                      </div>{' '}
                      <div className="topping">
                        <input
                          type="checkbox"
                          id="topping"
                          name="customerIsOwner"
                          value={'NO'}
                          checked={customerIsOwner === 'NO'}
                          onChange={handlecustomerIsOwner}
                        />
                        No
                      </div>
                      <div className="result">
                        {/* Above checkbox is {isChecked ? 'checked' : 'un-checked'}. */}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6"></div>
                  {customerIsOwner === 'NO' ? (
                    <>
                      <Input
                        bootstrap={'col-12 col-md-6'}
                        label={'Nombre del titular *'}
                        type={'text'}
                        name={'ownerFirstName'}
                        register={register}
                        placeholder={''}
                        errors={errors?.ownerFirstName?.message}
                      />
                      <Input
                        bootstrap={'col-12 col-md-6'}
                        label={'Apellido del titular *'}
                        type={'text'}
                        name={'ownerLastName'}
                        register={register}
                        placeholder={''}
                        errors={errors?.ownerLastName?.message}
                      />{' '}
                      <Input
                        bootstrap={'col-4 col-sm-2 col-md-2'}
                        label={'C.I / RIF*'}
                        type={'select'}
                        name={'ownerIdentificationType'}
                        register={register}
                        placeholder={''}
                        options={idCodes}
                        errors={errors?.ownerIdentificationType?.message}
                      />{' '}
                      <Input
                        bootstrap={'col-8 col-sm-4 col-md-4'}
                        label={'del titular*'}
                        type={'number'}
                        name={'ownerIdentification'}
                        register={register}
                        placeholder={''}
                        errors={errors?.ownerIdentification?.message}
                      />{' '}
                      <Input
                        bootstrap={'col-12 col-md-6'}
                        label={'Estado del titular *'}
                        type={'select'}
                        options={statesOptions}
                        name={'ownerState'}
                        placeholder={'Seleccione'}
                        register={register}
                        errors={errors?.ownerState?.message}
                        onChange={(e) => getOwnerCities()}
                      />{' '}
                      <Input
                        bootstrap={'col-12 col-md-6'}
                        label={'Ciudad del titular *'}
                        type={'select'}
                        options={ownerCitiesOptions}
                        name={'ownerCity'}
                        placeholder={'Seleccione'}
                        register={register}
                        errors={errors?.ownerCity?.message}
                      />{' '}
                      <Input
                        bootstrap={'col-12 col-md-6'}
                        label={'Dirección del titular *'}
                        type={'textarea'}
                        name={'ownerAddress'}
                        placeholder={''}
                        register={register}
                        errors={errors?.ownerAddress?.message}
                      />
                    </>
                  ) : null}
                  <div className="col-12 col-md-3"></div>
                </>
              )}{' '}
              {membership?.rcv !== 'N/A' && validateIfshowForm() && (
                <RcvHolderForm
                  register={register}
                  errors={errors}
                  setValue={setValue}
                  watch={watch}
                  citiesOptions={RCVCitiesOptions}
                  statesOptions={statesOptions}
                  handleCity={handleCity}
                  isVehicleDriver={isVehicleDriver}
                  handleRCVHolder={handleRCVHolder}
                />
              )}
            </div>
          </form>
        )}
        <div
          style={{ margin: '24px 0px 48px 0px' }}
          className="buttons-center-container"
        >
          <AltButton
            label={'Regresar'}
            action={() => setcurentStep(curentStep - 1)}
          />
          {validateButton()}
          {validateContinueButton()}
        </div>
      </div>
    </>
  );
});
